import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "layout flexRow" };
const _hoisted_2 = { class: "sidebar" };
const _hoisted_3 = {
    class: "main pgFlex",
    style: { "height": "calc(100% - 40px - 22px)" }
};
const _hoisted_4 = { class: "music_play" };
import { reactive, onMounted, onUnmounted, computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import emitter from '../../utils/eventBus';
import loginView from '../login/login.vue';
import musicChat from '../subview/music/music_chat/music_chat.vue';
import headerView from './components/header.vue';
import sidebar from './components/sidebar.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const route = useRoute();
        // 显示播放器
        const showPlay = ref(false);
        const musicChatInfo = ref();
        const playMusic = (value) => {
            showPlay.value = true;
            musicChatInfo.value = value;
        };
        // 获取展示背景图片的路由
        const showBgRoute = reactive([
            '/new-chat', '/nineHeavens', '/deepseek',
            '/intelligence_list', '/meeting/introduce', '/meeting/audioToText',
            '/simultaneousTranslation/introduce', '/imagecomprehend',
            '/writing', '/drawing'
        ]);
        const showBgRouteDetail = reactive([
            '/meeting/detail', '/meeting/room', '/simultaneousTranslation/generate'
        ]);
        const getRoutePath = computed(() => {
            return showBgRoute.findIndex((el) => el === route.fullPath) !== -1 || showBgRouteDetail.includes(route.path);
        });
        onMounted(() => {
            // 关闭音乐播放弹窗
            emitter.on('closeMusic', () => {
                showPlay.value = false;
                musicChatInfo.value = '';
            });
            emitter.on('playMusic', e => {
                playMusic(e);
            });
        });
        onUnmounted(() => {
            emitter.off('closeMusic');
            emitter.off('playMusic');
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(sidebar)
                ]),
                _createElementVNode("div", {
                    class: _normalizeClass(["pgFlex flexColumn layout_main", { layout_setting: _unref(route).name == '/setting', 'pageBg': getRoutePath.value }])
                }, [
                    _createVNode(headerView),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_Transition, { name: "el-fade-in" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_router_view)
                            ]),
                            _: 1
                        })
                    ]),
                    _cache[0] || (_cache[0] = _createElementVNode("div", {
                        class: "flexRow-alc flex-jcc ft12",
                        style: { "padding-bottom": "4px", "color": "#ccc" }
                    }, [
                        _createElementVNode("span", null, "内容由AI生成，仅供参考")
                    ], -1)),
                    _createVNode(_Transition, { name: "el-fade-in-linear" }, {
                        default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_4, [
                                _createVNode(musicChat, _normalizeProps(_guardReactiveProps(musicChatInfo.value)), null, 16)
                            ], 512), [
                                [_vShow, showPlay.value]
                            ])
                        ]),
                        _: 1
                    })
                ], 2),
                _createVNode(loginView)
            ]));
        };
    }
});
